// extracted by mini-css-extract-plugin
module.exports = {"slide":"PaymentEditForm_slide_d2yjd","slide-reverse":"PaymentEditForm_slide-reverse_3F8Pe","orderformSection":"PaymentEditForm_orderformSection_2kbbf"};